import { v4 as uuidv4 } from 'uuid';
import { deepClone, isBlank } from "@/common/utils";

export const issue = {
  state: {
    issues: {
      /*
        uuid,
        title,
        ref_no,
        desc,
        issue_category_uuid,
        recommendations:
        due,
        implementation,
        closed,
        timescale,
        responsible_person,
        severity,
        priority,
        status,
        owner_type:
        owner_uuid,
        created_at,
        updated_at
      */
    },
    site_issues: {

    }
  },
  mutations: {
    insertIssue(state, new_issue) {
      state.issues[new_issue.uuid] = new_issue;
    },

    insertSiteIssue(state, args) {
      if (state.site_issues[args.site_uuid]) {
        state.site_issues[args.site_uuid].push(args.issue_uuid);
      } else {
        state.site_issues[args.site_uuid] = [ args.issue_uuid ];
      }
    },

    updateIssue(state, payload) {
      const issue_uuid = payload.uuid;
      if (state.issues[issue_uuid]) {
        state.issues[issue_uuid] = payload;
      }
    },

    removeIssue(state, issue_uuid) {
      console.log("Inside issue.module.js, removeIssue(): issue_uuid ==> ", issue_uuid);
      const issue = state.issues[issue_uuid];
      console.log("Inside issue.module.js, removeIssue(): issue ==> ", issue);
      if (issue) {
        const site_uuid = issue.site_uuid
        delete state.issues[issue_uuid];
        state.site_issues[site_uuid] = state.site_issues[site_uuid].filter(function(aUUID) {
          return aUUID !== issue_uuid;
        });
        if (isBlank(state.site_issues[site_uuid])) {
          delete state.site_issues[site_uuid]
        }
      }
    },

    removeSiteIssues(state, site_uuid) {
      const issue_uuids = state.site_issues[site_uuid];
      issue_uuids.forEach(function(issue_uuid) {
        delete state.issues[issue_uuid];
      });
      delete state.site_issues[site_uuid];
    },

    removeAllIssues(state) {
      state.issues = {};
      state.site_issues = {};
    },

    clearIssuesIndex(state) {
      state.site_issues = {};
    }
  },
  actions: {
    addIssue({ commit }, payload) {
      //console.log("Inside issue.module.js, addIssue(), payload ==> ", payload);
      const new_issue = payload
      if (!new_issue.uuid) {
        new_issue.uuid = uuidv4();
        new_issue.created_at = new Date().toISOString();
        new_issue.updated_at = new Date().toISOString();
        console.log("Inside issue.module.js, addIssue(), new_issue ==> ", new_issue);
      }
      commit("insertIssue", new_issue);
      commit("insertSiteIssue", { site_uuid: new_issue.site_uuid, issue_uuid: new_issue.uuid });
      return new_issue.uuid;
    },

    modifyIssue({ commit }, payload) {
      let issue = payload;
      issue.updated_at = new Date().toISOString();
      commit("updateIssue", issue);
    },

    timestampIssueSync({ commit, getters }, issue_uuid) {
      const issue = getters.getIssueByUUID(issue_uuid);
      issue.sync_on = new Date().toISOString();
      commit("updateIssue", issue);
    },

    reindexIssues({ commit, getters }) {
      commit("clearIssuesIndex");
      const all_issues = Object.values(getters.allIssues);
      all_issues.forEach(function(issue) {
        commit("insertSiteIssue", { site_uuid: issue.site_uuid, issue_uuid: issue.uuid });
      })
    },

    deleteIssue({ commit }, issue_uuid) {
      commit("removeIssue", issue_uuid);
    },

    deleteIssuesByOwner({ getters, dispatch }, owner_uuid) {
      const all_issues = getters.allIssuesByOwner(owner_uuid);
      console.log("Inside issue.module.js, deleteIssuesByOwner(), all_issues ==> ", all_issues);
      all_issues.forEach(function(issue) {
        dispatch('deleteIssue', issue.uuid);
      })
    },

    deleteIssuesBySite({ getters, dispatch }, site_uuid) {
      const all_issues = getters.getIssuesBySiteUUID(site_uuid);
      console.log("Inside issue.module.js, deleteIssuesBySite(), all_issues ==> ", all_issues);
      all_issues.forEach(function(issue) {
        dispatch('deleteIssue', issue.uuid);
      })
    },

    clearAllIssues({ commit }) {
      commit("removeAllIssues");
    }
  },
  getters: {
    allIssues(state) {
      return state.issues
    },

    allSiteIssues(state) {
      return state.site_issues
    },

    getIssueByUUID(state) {
      return function(uuid) {
        const issue = state.issues[uuid];
        return issue ? deepClone(issue) : null;
      }
    },

    getIssuesBySiteUUID(state, getters) {
      return function(site_uuid) {
        const issue_uuids = state.site_issues[site_uuid];
        if (issue_uuids) {
          return issue_uuids.map(function(issue_uuid) {
            return getters.getIssueByUUID(issue_uuid);
          });
        } else {
          return []
        }
      }
    },

    nbIssuesBySite() {
      return function(owner_uuid) {
        return this.getIssuesBySiteUUID(owner_uuid).length
      }
    },

    allIssuesByOwner(state) {
      return function(owner_uuid) {
        return Object.values(state.issues).filter(function(issue) {
          return issue.owner_uuid == owner_uuid;
        })
      }
    },    

    searchIssuesBy(state, getters) {
      return function(args) {
        console.log("Inside issue.module.js # searchIssuesBy() args ==> ", args);
        let issues = (args.site_id) ? getters.getIssuesBySiteUUID(args.site_id) : state.issues;
        if (args.asset_id) {
          issues = issues.filter(function(issue) {
            return issue.owner_uuid == args.asset_id;
          })
        }
        if (args.location_id) {
          issues = issues.filter(function(issue) {
            return issue.owner_uuid == args.location_id;
          })
        }
        if (args.owner_id) {
          issues = issues.filter(function(issue) {
            return issue.owner_uuid == args.owner_id; // UUID, no need to worry about owner_type
          });
        }
        return issues;
      }
    },

    getIssueOwner(state, getters) {
      return function(issue) {
        return getters.getObjectByUUID(issue.owner_type, issue.owner_uuid)
      }
    }

  }
}